import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { API_URL } from '../Shared/constants/url.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FacultyService {

  constructor(private http: HttpClient) { }
  GetFaculty(): Observable<any> {
    const httpBody = new HttpParams()
      .set('SeoName', 'Faculty');
    return this.http.post(API_URL.GETWEBPAGE, httpBody);
  }
  GetFacultyData(seoname): Observable<any> {
    const httpBody = new HttpParams()
      .set('SeoName', seoname);
    return this.http.post(API_URL.GETWEBPAGE, httpBody);
  }
}
